<div id="dynamic" class="hidden" style="display: block;">

    <h2>ABOUT</h2>
    <img id="ctl00_Image4" src="../../../assets/images/Heads.jpg" alt="People">
    <br><br>
    <div style="width:650px; text-align:left;padding-top:10px;">
    
              <span class="Highlight">Elizabeth Warwick</span> and <span class="Highlight">Andrew Pawlowski</span>, the principals of Salt Studio, have practiced their distinctive brand of architecture from the beachside suburb of Glenelg in South Australia since 1992, with a commitment to innovation, sensitivity, sustainability and fun. 
              <br><br>
            Each project is approached as a new beginning; the provision of built form that fulfils the required outcomes through a fresh and stimulating, often unexpected, but always satisfying process. 
            <br><br>
            Responsility for our environment informs all of our work; each and every project is approached with a view to maximising passive energy principals, and incorporating proven energy and water saving systems.
            <br><br>
            We take pride in being good listeners, embracing our client's vision and converting this into an exciting, and stress-free, reality. 
            <br><br>
            Our new offices at 716 Anzac Highway Glenelg have become the centre of a development hub; we share space and work collaboratively with Town Planning HQ, Donaghey Surveyors and Salt e-House builders, and can cover every development requirement.
            <br><br>
            Feel free to drop in and see us for a chat about your next project.
        </div>
    
    
    <div style="padding-top:20px; ">        
    
    </div>
    
    
    
    
    
    
    
    <title>
        Salt Studio
    </title>
    
        
    <div class="aspNetHidden">
    <input type="hidden" name="__VIEWSTATE" id="__VIEWSTATE" value="/wEPDwUJNzgzNDMwNTMzZGQNtREkIS17khVYH/qXumLpj6RT8ytE9p8tvLTuNelCpg==">
    </div>
    
    <div class="aspNetHidden">
    
        <input type="hidden" name="__VIEWSTATEGENERATOR" id="__VIEWSTATEGENERATOR" value="E146D275">
    </div>
        <div>
        
        </div>
        
    
    
    </div>
